import React from "react";
import "./Branch.scss";

const Branch = ({ address, name, distance, schedules }) => (
  <div className="branch-list">
    <div className="branch-list__name">{name}</div>
    <div className="branch-list__address">{address}</div>
    <div className="branch-list__schedule">{schedules}</div>
    <div className="branch-list__distance">{distance} km away</div>
  </div>
);

export default Branch;
